import React, { useEffect, memo, useState } from "react"
import AOS from "aos"
import SimpleBar from "simplebar-react"
import { useLocation } from "@reach/router"
import parse from "html-react-parser"
import PostCommentForm from "../postCommentForm/postCommentForm"
import "aos/dist/aos.css"
import "simplebar-react/dist/simplebar.min.css"
import BlogDetailBanner from "../blogDetailBanner/blogDetailBanner"
import OptimizedImage from "../ImageShow/OptimizedImage"
import axios from "axios"
import BlogFaq from "../faq/blogFaq"
import * as style from "./blogDetailInfo.module.css"
import { useHomeNewMetadata } from "../../queries/useHomeNewMetaData"

const BlogDetailInfo = ({
  generalSettingsUrl,
  content,
  table_of_content,
  blogImage,
  title,
  bannerDatas,
  blogImageAltTxt,
  singlePageFieldsNew,
  categories,
  databaseId,
  viewsCount,
  viewsCountShowSection,
}) => {
  const location = useLocation()

  const WordpressUrl = `${generalSettingsUrl}/${
    location.pathname?.split("/")[2]
  }/`

  const [showData, setShowData] = useState([])

  useEffect(() => {
    axios({
      method: "post",
      url: `${process.env.GATSBY_API_URL}/wp-json/agile/v1/post_comments/?postid=${databaseId}`,
    })
      .then(function (response) {
        //handle success
        setShowData(response?.data?.comments)
      })
      .catch(function (response) {
        //handle error
        // console.log(response);
      })
  }, [])

  useEffect(() => {
    const links = document.querySelectorAll('a[href*="#"]:not([href="#"])')
    const OFFSET = 100 // Adjust this value based on your fixed header height

    function clickHandler(e) {
      e.preventDefault()

      const targetId = this.getAttribute("href").substring(1)
      const targetElement = document.getElementById(targetId)

      if (targetElement) {
        const offsetTop =
          targetElement.getBoundingClientRect().top + window.scrollY - OFFSET

        window.scrollTo({
          top: offsetTop,
          behavior: "smooth",
        })
      }
    }

    links.forEach(link => link.addEventListener("click", clickHandler))

    return () => {
      links.forEach(link => link.removeEventListener("click", clickHandler))
    }
  }, [table_of_content]) // Ensure it runs when `table_of_content` updates

  // TODO : once the code uploaded on live the it's working completely then remove it

  // useEffect(() => {
  //   const links = document.querySelectorAll('a[href*="#"]:not([href="#"])')

  //   for (const link of links) {
  //     link.addEventListener("click", clickHandler)
  //   }

  //   function clickHandler(e) {
  //     e.preventDefault()
  //     const href = this.getAttribute("href")
  //     const removeNumber = decodeURIComponent(href)?.replace(/\d+/g, "")
  //     const secondCharacter = href.substring(1, 2)
  //     const uri = decodeURI(href)

  //     let offsetTop = 0
  //     console.log('secondCharacter: ', secondCharacter);
  //     if (!isNaN(secondCharacter)) {
  //       offsetTop = document?.querySelector(removeNumber)?.offsetTop + 0
  //       console.log('if offsetTop: ', offsetTop);
  //     } else {
  //       offsetTop =
  //         document?.querySelector(href?.replace(href, uri))?.offsetTop + 0
  //         console.log('else offsetTop: ', offsetTop);
  //     }

  //     window.scroll({
  //       top: offsetTop,
  //       behavior: "smooth",
  //     })
  //   }
  // }, [table_of_content])

  useEffect(() => {
    AOS.init({
      once: true,
    })
  }, [])

  const urlReplace = content => {
    if (content) {
      let newPath = content?.replaceAll(WordpressUrl, "")
      return newPath
    } else {
      return content
    }
  }

  const getUpdatedContent = () => {
    // Assuming you have a variable `dynamicHtmlContent` containing the dynamic HTML content
    const dynamicHtmlContent = content

    // Create a temporary container element to hold the HTML content
    const container = document.createElement("div")
    container.innerHTML = dynamicHtmlContent

    // Find all <span> elements within the container
    const spanElements = container.getElementsByTagName("span")

    // Loop through each <span> element and remove the number from the id attribute
    for (let i = 0; i < spanElements.length; i++) {
      const spanElement = spanElements[i]
      const id = spanElement.getAttribute("id")
      const updatedId = id?.replace(/^\d+/, "")

      spanElement.setAttribute("id", decodeURIComponent(updatedId))
    }

    // Get the modified HTML content from the container
    return container.innerHTML
  }

  // const handleBackEvent = () => {
  //   if (window !== undefined && window?.history?.length > 1) {
  //     navigate(-1)
  //   } else {
  //     navigate("/blogs/?page=1")
  //   }
  // }

  const homeData = useHomeNewMetadata()

  const { faqContent, faqSubTitle, faqTitle } =
    homeData?.wpPage?.homePageNewFields

  const [scrolled, setScrolled] = useState(0)

  const progressBarScroll = () => {
    const winScroll =
      document.body.scrollTop || document.documentElement.scrollTop
    const height =
      document.documentElement.scrollHeight -
      document.documentElement.clientHeight
    const scrolled = (winScroll / height) * 100
    setScrolled(scrolled)
  }

  useEffect(() => {
    window.addEventListener("scroll", progressBarScroll)
    return () => window.removeEventListener("scroll", progressBarScroll)
  }, [])

  return (
    <>
      <div class="progress-container">
        <div
          class="progress-bar"
          style={{
            width: `${scrolled}%`,
            backgroundColor: "#E95444",
            borderRadius: "0 10px 10px 0",
            height: "5px",
          }}
          id="progressBar"
        ></div>
      </div>

      <section className={style.blog_detail}>
        <div className="container">
          <div className={style.blog_detail_wrapper}>
            <div className={style.blog_detail_left}>
              <BlogDetailBanner
                blogImage={blogImage}
                blogImageAltTxt={blogImageAltTxt}
                title={title}
                bannerData={bannerDatas}
                categories={categories}
                singlePageFieldsNew={singlePageFieldsNew}
                countView={viewsCount}
                viewsCountShowSection={viewsCountShowSection}
                databaseId={databaseId}
              />
              <div className={style.wrapperBlogContent}>
                <OptimizedImage
                  imageData={
                    blogImage ? blogImage : "/images/placeholder-image.jpg"
                  }
                  alt={blogImageAltTxt}
                />

                {content ? parse(`${getUpdatedContent()}`) : ""}
              </div>

              <OptimizedImage
                imageData="/images/StarLine.svg"
                alt="star-Line"
                pictureclass="starPicture"
              />

              <div></div>

              <BlogFaq
                faqContent={faqContent}
                faqShowSection={singlePageFieldsNew.showFaqsSection}
                faqSubTitle={faqSubTitle}
                faqTitle={faqTitle}
                faqQuestionAnswerList={singlePageFieldsNew.faqs}
              />

              <PostCommentForm CustomClass="" />

              <div className={style.commentListbox}>
                <SimpleBar
                  style={{ maxHeight: 440 }}
                  forceVisible="y"
                  autoHide={false}
                >
                  <ul>
                    {showData?.map(val => {
                      var str = val.comment_author
                      var matches = str.match(/\b(\w)/g)
                      var commentShortName = matches?.join("")

                      return val.comment_approved == "1" ? (
                        <li>
                          <div className={style.commentBox}>
                            <div className={style.commentTitle}>
                              <div className={style.shortName}>
                                {commentShortName}
                              </div>
                              <span>{val.comment_author}</span>
                            </div>
                            <div className={style.commentInfo}>
                              <p> {parse(`${val.comment_content}`)}</p>
                              <span>{val.comment_date?.split(" ")[0]}</span>
                            </div>
                          </div>
                        </li>
                      ) : (
                        ""
                      )
                    })}
                  </ul>
                </SimpleBar>
              </div>
            </div>
            <div className={style.blog_info_right} id="myHeader2">
              <h2>Table of contents</h2>
              <SimpleBar
                style={{ maxHeight: "480px" }}
                forceVisible="y"
                autoHide={false}
              >
                {parse(urlReplace(`${table_of_content}`))}
              </SimpleBar>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default memo(BlogDetailInfo)
